import { Helmet } from 'react-helmet'

const Seo = ({ title, description, path = '/', image = '', noindex = false }) => {
  const baseUrl = 'https://leanit101.com'
  const url = `${baseUrl}${path}`
  const resolvedImage = image
    ? image.startsWith('http')
      ? image
      : `${baseUrl}${image}`
    : `${baseUrl}/images/og-leanit101-v2.jpg`

  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      {noindex ? <meta name="robots" content="noindex,nofollow" /> : null}
      {noindex ? <meta name="googlebot" content="noindex,nofollow" /> : null}
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? (
        <meta property="og:description" content={description} />
      ) : null}
      <meta property="og:image" content={resolvedImage} />
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? (
        <meta name="twitter:description" content={description} />
      ) : null}
      <meta name="twitter:image" content={resolvedImage} />
    </Helmet>
  )
}

export default Seo
